<template>
  <span>Please wait while being redirect</span>
</template>
<script setup>
import { onBeforeMount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
const route = useRoute()
const router = useRouter()

onBeforeMount(() => {
  const location = route.fullPath
  // console.log({ location })
  if (location.includes('/polls/')) {
    const splittedArr = location.split('/')
    const id = splittedArr[splittedArr.length - 1]
    // console.log({ id })
    router.replace({ name: 'polls', params: { id } })
  } else {
    window.location.assign(route.query?.ref)
  }
})
</script>
